<template>
  <div>
    <NBar title="启动页消息通知" :top="true"/>
    <div class="msg-top">
      <template v-if="addressList.length == 1">
        <div class="name">
          <span>{{addressList[0].name}}</span>
          <span class="label">{{addressList[0].deviceCount}}台</span>
        </div>
        <span class="address">{{addressList[0].address}}</span>
      </template>
      <div class="name" v-else>已选{{addressList.length}}个场地</div>
      <div class="title-div">
        <span class="left-title">启动页效果预览</span>
        <span class="right-title">可设置礼品上新，优惠活动等消息</span>
      </div>
      <div class="hint-panel">
        <div class="fun-panel">
          <div class="part">
            <img
              src="data:image/png;base64,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"
              class="head-pic">
            <span>余币：</span>
            <span>10</span>
            <span class="pl-10">机器：1号 ></span>
          </div>
          <div class="part">
            <span>会员中心</span>
            <span class="plr-10">|</span>
            <span>发弹幕</span>
          </div>
        </div>
      </div>
    </div>
    <nut-cell :show-icon="false" style="margin-top: 10px">
      <span slot="title" style="color: #999;">消息内容</span>
      <span slot="desc" style="color:#3a78e3;font-size: 14px;" @click="addContent">添加消息内容</span>
    </nut-cell>
    <nut-cell v-for="(item,index) in list" :key="'msg-content-'+index" :show-icon="false">
      <div slot="title">
        <nut-radio v-model="form.content" :label="item.id">{{item.content}}</nut-radio>
      </div>
      <div v-if="item.id != 0" slot="desc" class="desc-btn">
        <div class="btn left-btn">编辑</div>
        <div class="btn" @click="delTap(item)">删除</div>
      </div>
    </nut-cell>
    <nut-dialog title="添加消息内容" :visible="dialogShow" @ok-btn-click="saveMsg(1)"
                @cancel-btn-click="dialogShow=false" @close="dialogShow=false"
                okBtnTxt="保存">
      <nut-textbox v-model="content" :place-text="'最多输入50个字'"></nut-textbox>
    </nut-dialog>
    <nut-cell :show-icon="false" class="diy-cell" style="margin-top: 10px">
      <span slot="title" style="color: #999;">消息标签</span>
      <span slot="desc" style="color:#3a78e3;font-size: 14px;" @click="addLabel()">添加标签</span>
    </nut-cell>
    <nut-cell v-for="(item,index) in labelList" :key="'msg-label-'+index" :show-icon="false">
      <div slot="title">
        <nut-radio v-model="form.label" :label="item.id">{{item.content}}</nut-radio>
      </div>
      <div v-if="item.id != -1 && item.id != 0" slot="desc" class="desc-btn">
        <div class="btn left-btn">编辑</div>
        <div class="btn" @click="delTap(item)">删除</div>
      </div>
    </nut-cell>
    <nut-dialog title="添加消息标签" :visible="dialogLabelShow" @ok-btn-click="saveMsg(0)"
                @cancel-btn-click="dialogLabelShow=false" @close="dialogLabelShow=false"
                okBtnTxt="保存">
      <nut-textbox v-model="content" :place-text="'最多输入6个字'" :max-num="6"></nut-textbox>
    </nut-dialog>
    <nut-dialog title="提示" :visible="delDialogShow" @ok-btn-click="delMsg()" @cancel-btn-click="delDialogShow=false"
                @close="delDialogShow=false">
      <span v-if="delData.type == 0">确认要删除消息标签?</span>
      <span v-if="delData.type == 1">确认要删除消息内容?</span>
    </nut-dialog>
    <nut-button block class="save-btn" @click="save">保存</nut-button>
  </div>
</template>

<script>
export default {
  name: 'MsgSet',
  props: ['type', 'data'],
  data () {
    return {
      content: '',
      labelList: [{
        id: -1,
        type: 0,
        content: '礼品上新',
      }, {
        id: 0,
        type: 0,
        content: '优惠活动',
      }],
      list: [{
        id: 0,
        type: 1,
        content: '无消息',
      }],
      delData: {},
      delDialogShow: false,
      dialogShow: false,
      dialogLabelShow: false,
      user: {},
      addressList: [{}],
      form: {
        id: null,
        addressIds: [],
        merId: null,
        storeId: null,
        startMsg: '',
        content: 0,
        label: null,
      },
    }
  },
  mounted () {
    this.form.merId = this.$api.merId
    this.form.storeId = this.$api.storeId
    this.user = this.$api.user
    if (this.data != null) {
      let data = JSON.parse(decodeURIComponent(this.data))
      this.addressList = data
      this.addressList.forEach(item => {
        this.form.addressIds.push(item.id)
      })
      if (this.addressList.length == 1) {
        this.getData()
      }
      this.getMsg()
    }
  },
  methods: {
    getData () {
      this.$api.post({
        url: '/device/api/system/device-address-system-set/find',
        data: {
          merId: this.user.merId,
          storeId: this.user.storeId,
          addressId: this.addressList[0].id
        }
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          this.$util.ofData(this.form, res.data)
          if (!this.$util.isArrOrNull(this.form.startMsg)) {
            let startMsgs = this.form.startMsg.split(',')
            for (let i = 0; i < startMsgs.length; i++) {
              if (i == 0) {
                this.form.content =  parseInt(startMsgs[i])
              } else {
                this.form.label = parseInt(startMsgs[i])
              }
            }
          }
        }
      })
    },
    getMsg () {
      this.$api.post({
        url: '/device/api/device/device-msg/list',
        data: {
          merId: this.user.merId,
          storeId: this.user.storeId,
        }
      }).then(res => {
        if (!this.$util.isArrOrNull(res.data)) {
          res.data.forEach(item => {
            if (item.type = 0) {
              this.labelList.push(item)
            } else {
              this.list.push(item)
            }
          })
        } else {
          this.labelList = [{
            id: -1,
            type: 0,
            content: '礼品上新',
          }, {
            id: 0,
            type: 0,
            content: '优惠活动',
          }]
          this.list = [{
            id: 0,
            type: 1,
            content: '无消息',
          }]
        }
      })
    },
    //保存消息
    saveMsg (type) {
      if (type == 0 && this.$util.isArrOrNull(this.content)) {
        this.$toast.warn('标签不能为空')
        return
      }
      if (type == 1 && this.$util.isArrOrNull(this.content)) {
        this.$toast.warn('内容不能为空')
        return
      }
      this.$api.post({
        url: '/device/api/device/device-msg/save',
        data: {
          merId: this.user.merId,
          storeId: this.user.storeId,
          type: type,
          content: this.content
        }
      }).then(() => {
        if (type == 0) {
          this.dialogShow = false
        } else {
          this.dialogLabelShow = false
        }
        this.getMsg()
      })
    },
    delTap (item) {
      this.delData = item
      this.delDialogShow = true
    },
    delMsg () {
      this.$api.delete({
        url: '/device/api/device/device-msg/delete',
        id: this.delData.id
      }).then(() => {
        this.delDialogShow = false
        this.getMsg()
      })
    },
    save () {
      if (!this.$util.isArrOrNull(this.form.content))
        this.form.startMsg = this.form.content
      if (!this.$util.isArrOrNull(this.form.label))
        this.form.startMsg += ',' + this.form.label
      this.$api.post({
        url: '/device/api/system/device-address-system-set/save',
        data: this.form
      }).then(() => {
        setTimeout(() => {
          if (this.type != null) {
            this.$router.go(-2)
          } else {
            this.$router.go(-1)
          }
        }, 2000)
      })
    },
    addContent () {
      this.dialogShow = true
    },
    addLabel () {
      this.dialogLabelShow = true
    },
  }
}
</script>

<style scoped>
  .msg-top {
    background: #fff;
    padding: 10px;
  }

  .msg-top .name {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 15px;
    margin-bottom: 5px;
  }

  .msg-top .name .label {
    background: #409EFF;
    padding: 0 5px;
    color: #fff;
    border-radius: 2px;
    margin-left: 10px;
    font-size: 12px;
  }

  .msg-top .address {
    color: #999;
    font-size: 13px;
  }

  .title-div {
    margin: 8px 0;
  }

  .title-div .left-title {
    font-size: 15px;
  }

  .title-div .right-title {
    color: #999;
    margin-left: 10px;
  }

  .hint-panel {
    display: flex;
    flex-direction: column;
  }

  .hint-panel .fun-panel {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    background-color: #fc4f63;
    padding: 5px 10px;
    border-radius: 5px;
  }

  .hint-panel .fun-panel .part {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .hint-panel .fun-panel .part .head-pic {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    margin-right: 10px;

  }

  .hint-panel .fun-panel .part .plr-10 {
    padding: 0 5px;
  }

  .desc-btn {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .desc-btn .btn {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 25px;
    line-height: 25px;
    padding: 0 10px;
    border: 1px solid #d0d0d0;
    border-radius: 5px;
  }

  .desc-btn .left-btn {
    margin-right: 10px;
  }

  .save-btn {
    margin-top: 20px;
  }

  >>> .nut-button {
    background: #409EFF;
  }

  >>> .nut-radio input:checked {
    background-color: #007aff;
    border-color: #007aff;
  }

  >>> .nut-radio input:after {
    background: #007aff;
  }

  >>> .nut-dialog-ok {
    background: #007aff;
  }
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/MsgSet.vue